import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import api from '../api';

export const deleteLoyaltyProgram = async (id) => {
  try {
    await api.delete(`/loyalty/program/${id}`);

    return new Success(true);
  } catch (error) {
    console.log(error);
    return new Failure();
  }
};
